import React, { createContext, useEffect, useState } from "react";
export function getInputValue(input) {
    switch (input.type) {
        case "number": return Number(input.value);
        case "checkbox": return input.checked;
        default: return input.value;
    }
}
function sendMessage() { }
function clearError() { }
function syncedTime() { return Date.now(); }
export function createStorybookContext(appState, updater, userState, user, lobby) {
    var preciseContext = createContext({
        appState: appState,
        userState: userState,
        user: user,
        lobby: lobby,
        sendMessage: sendMessage,
        clearError: clearError,
        syncedTime: syncedTime
    });
    var EngageContextProvider = function (_a) {
        var children = _a.children;
        var _b = useState(appState), storedState = _b[0], setAppState = _b[1];
        useEffect(function () {
            // @ts-ignore
            return updater(setAppState);
        }, []);
        return React.createElement(preciseContext.Provider, { value: {
                lobby: lobby,
                userState: userState,
                user: user,
                sendMessage: sendMessage,
                errorMap: {},
                clearError: clearError,
                lobbyValidation: undefined,
                syncedTime: syncedTime,
                appState: storedState
            } }, children);
    };
    return {
        context: preciseContext,
        Provider: EngageContextProvider
    };
}
//# sourceMappingURL=utils.js.map